import Graph from "shared/assets/svg/graph.svg?react";
import StarInCircle from "shared/assets/svg/star-in-circle.svg?react";
import { Button } from "shared/ui/button";
import { Spinner } from "shared/ui/spinner";
import { cn } from "shared/utils/cn";

import scoreSvg from "../assets/score.svg";

type Props = {
  isLoading: boolean;
  sybilScore: string;
  tradingScore: string;

  onIssue: () => void;
};

export const Score = (props: Props) => {
  const { sybilScore, tradingScore, isLoading, onIssue } = props;
  return (
    <>
      <img src={scoreSvg} className="h-[131px]" alt="your score" />
      <h2 className="mt-5 text-center text-[21px] font-semibold whitespace-nowrap">
        {`Preparing your zkCertificate`}
      </h2>

      <div className="relative mt-5 flex w-full grow flex-col">
        {isLoading && (
          <Spinner className="text-balticSea/50 absolute top-20 left-1/2 size-10 -translate-x-1/2" />
        )}
        <div
          className={cn(
            "border-persianOrange mb-5 flex flex-col rounded-xl border-2 bg-white p-4.5 pb-5",
            isLoading && "opacity-35"
          )}
        >
          <h3 className="text-balticSea text-lg leading-6 font-medium">
            Your Data from Blum
          </h3>
          <p className="text-balticSea/50 mt-1 leading-5">
            Certificate will contain next fields
          </p>

          <div className="mt-4.5 flex items-center gap-x-3">
            <StarInCircle className="text-persianOrange size-6" /> Sybil Score:
            <span className="text-balticSea ml-auto inline-flex font-semibold">
              {sybilScore}
            </span>
          </div>
          <div className="mt-3 flex items-center gap-x-3">
            <Graph className="text-persianOrange size-6" /> Trading Score:
            <span className="text-balticSea ml-auto inline-flex font-semibold">
              {tradingScore}
            </span>
          </div>
        </div>

        <Button
          className={cn("mt-auto", isLoading && "opacity-35")}
          onClick={onIssue}
        >
          Issue zkCertificate
        </Button>
      </div>
    </>
  );
};
